import settingsReducer from './settingsReducer';
import Settings from './settings';

export { settingsReducer };

export * from './settingsActions';

export default Settings;
